import { SerializedEditorState, SerializedLexicalNode } from '@payloadcms/richtext-lexical/lexical'

import About from '@/components/HomeTabContent/components/About'
import { CMSLinkType } from '@/components/Link'
import { Media } from '@/payload-types'

import Collection from './components/Collection'

export interface TabContentProps {
  title: string
  image?: Media
  content: SerializedEditorState<SerializedLexicalNode>
  type: 'aboutBlock' | 'collectionBlock'
  link: CMSLinkType
  impactRow?:
    | {
        impact?: {
          icon?: string | null
          content?: string | null
        }
        id?: string | null
      }[]
    | null
  collectionType?: 'organizations' | 'wins' | null | undefined
  join?:
    | {
        join: {
          link: CMSLinkType
          content?: string | null
        }
        id?: string | null
      }[]
    | null
}

const HomeTabContent: React.FC<TabContentProps> = ({
  title,
  image,
  content,
  type,
  link,
  join,
  impactRow,
  collectionType,
}) => {
  return type === 'aboutBlock' ? (
    <About
      title={title}
      image={image as Media}
      content={content}
      link={link}
      type={type}
      join={join}
      impactRow={impactRow}
    />
  ) : (
    <Collection
      title={title}
      content={content}
      type={type}
      link={link}
      collectionType={collectionType}
    />
  )
}

export default HomeTabContent
